// extracted by mini-css-extract-plugin
export default {"logo":"index_logo_z9cOz"};